export const PaidCustomSection: React.FC<{
    customSection: React.ReactNode;
}> = ({
    // eslint-disable-next-line react/prop-types
    customSection
}) => {
    return <>{customSection}</>;
};
PaidCustomSection.displayName = "Custom";
